module.exports = "img/flags/SY.200f38a.png";